import { SortOrderEnum } from '@shared/types';
import { TableColumn } from '@ui-kit/table/_core/ui-table-config.interface';
import { orderBy } from 'lodash-es';
import { TimezoneHelper } from './timezone.helper';

function convertDateToString(date: Date) {
    const month: number = date.getMonth() + 1;
    return `${date.getFullYear()}/${month}/${date.getDate()}`;
}

function convertToNumberArray(input: any | any[]): number[] {
    if (!input) {
        return [];
    }
    if (Array.isArray(input)) {
        return input.map(inputValue => {
            return parseInt(inputValue);
        });
    }
    return [parseInt(input)];
}

function computeDateRange(dateRange: Date[]): { startDate: Date | null; endDate: Date | null } | null {
    if (!dateRange || dateRange.length !== 2) {
        return null;
    }

    const startDate = dateRange[0];
    const endDate = dateRange[1];

    return {
        startDate: startDate ? TimezoneHelper.startOfDateUTC(startDate) : null,
        endDate: endDate ? TimezoneHelper.endOfDateUTC(endDate) : null,
    };
}

function computePayloadSortingCriteria<T>(columns: TableColumn<T>[]): {
    sortingCriteria: { criterion: T; order: SortOrderEnum }[];
} {
    return {
        sortingCriteria: orderBy(columns, ['sortPriority'])
            .filter(c => c.isSortingActive)
            .map(c => {
                return {
                    criterion: c.field,
                    order: c.sortOrder || SortOrderEnum.ASC,
                };
            }),
    };
}

function trimStrings(obj: any): any {
    if (typeof obj === 'string') {
        return obj.trim() || null;
    } else if (typeof obj === 'object' && obj !== null) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                obj[key] = GeneralHelper.trimStrings(obj[key]);
            }
        }
    }
    return obj;
}

export const GeneralHelper = {
    convertDateToString,
    convertToNumberArray,
    computeDateRange,
    computePayloadSortingCriteria,
    trimStrings,
};
